export default "__VITE_ASSET__DIMKu9fG__"